/**
 * 社会服务相关API接口
 * 实现服务搜索、机构详情查询等功能
 */

import { req } from '../utils/request'

export class Service {
  /**
   * 搜索服务
   * @param {String} keyword - 搜索关键词
   * @returns {Promise}
   */
  searchServices(keyword) {
    return req.get('user.service/search', { keyword })
  }
  
  /**
   * 获取服务详情
   * @param {Number} id - 服务ID
   * @returns {Promise}
   */
  getServiceDetail(id) {
    return req.get('user.service/detail', { id })
  }
  
  /**
   * 获取机构会员详情（包含服务信息）
   * @param {Number} userId - 用户ID
   * @returns {Promise}
   */
  getOrganizationDetail(userId) {
    return req.get('user.service/organization', { user_id: userId })
  }
}

export default new Service()
